<header-bar title="Abo Verwaltung"></header-bar>
<div class="page-content">
    <div style="padding: 12px">
        <h2 class="text-white text-left text-uppercase mb-2">
            Mitgliedschafts-Abo
        </h2>
        <p class="font-weight-bolder text-white mt-4 mb-0">
            Dein aktuelles Abo ist:
        </p>
        <h4 class="text-white text-left text-uppercase">
            <%= ( null !== currentMembershipPlan ) ? currentMembershipPlan.name : 'Spezialangebot' %>
        </h4>
        <p class="font-weight-bolder text-white mt-4 mb-1">
            Wähle ein neues Abo
        </p>
        <div class="input-style has-borders no-icon mb-4" style="border-radius: 10px;padding:0;">
            <label for="membershipPlanSelection" class="color-highlight">Select A Value</label>
            <select id="membershipPlanSelection"
                    data-id="newMembershipPlanId"
                    class="font-weight-bolder">
                <% for ( let pi = 0; pi < membershipPlans.length; pi++ ) {  %>
                    <option value="<%= membershipPlans[ pi ].planId %>"><%= membershipPlans[ pi ].name %></option>
                <% }    %>
            </select>
            <span><i class="fa fa-chevron-down"></i></span>
        </div>
        <div id="paypal-button-container-membership" style="padding: 0 16px"></div>
        <hr class="mt-4 mb-4" />
        <h2 class="text-white text-left text-uppercase mb-2">
            Motivationsbeitrag
        </h2>
        <p class="font-weight-bolder text-white mt-4 mb-0">
            Dein aktueller Motivationsbeitrag beträgt:
        </p>
        <h4 class="text-white text-left text-uppercase">
            <%= currentMotivationPlan ? currentMotivationPlan.name : '---'  %>
        </h4>
        <p class="font-weight-bolder text-white mt-4 mb-1">
            Wähle auf Wunsche ein neuen Motivationsbetrag aus:
        </p>
        <div class="input-style has-borders no-icon mb-4" style="border-radius: 10px;padding:0;">
            <label for="motivationBonusSelection" class="color-highlight">Select A Value</label>
            <select id="motivationBonusSelection"
                    data-id="newMotivationBonusPlanId"
                    class="font-weight-bolder">
                <% for ( let pi = 0; pi < motivationPlans.length; pi++ ) {  %>
                    <option value="<%= motivationPlans[ pi ].planId %>"><%= motivationPlans[ pi ].name %></option>
                <% }    %>
            </select>
            <span><i class="fa fa-chevron-down"></i></span>
        </div>

        <div id="paypal-button-container-motivation" style="padding: 0 16px"></div>
    </div>
</div>
<main-menu></main-menu>
